<template>
  <span v-if="invoiceStatus == 'new'" class="badge badge-info py-1 px-2">Yeni</span>
  <span v-else-if="invoiceStatus == 'paid'" class="badge badge-success py-1 px-2">Ödendi</span>
  <span v-else-if="invoiceStatus == 'new_cancelled'" class="badge badge-warning py-1 px-2">İptal</span>
  <span v-else-if="invoiceStatus == 'paid_cancelled'" class="badge badge-warning py-1 px-2">İptal</span>
  <span v-else class="badge badge-warning py-1 px-2">Yok</span>
</template>

<script>
export default {
  name: "invoiceStatus",
  props:{
    invoiceStatus:String
  }
}
</script>

<style scoped>

</style>